var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPathways(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 3,
    stroke: "#ffffff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 3,
    stroke: "#ffffff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 4.25C10.586 4.25 10.2502 4.58579 10.2502 5C10.2502 5.41421 10.586 5.75 11.0002 5.75V4.25ZM13.0002 19L13.5305 19.5303C13.8234 19.2374 13.8234 18.7626 13.5305 18.4697L13.0002 19ZM17.2059 8.68732L17.6085 9.32007L17.2059 8.68732ZM6.79459 15.3127L7.19725 15.9454H7.19725L6.79459 15.3127ZM12.0305 16.9697C11.7377 16.6768 11.2628 16.6768 10.9699 16.9697C10.677 17.2626 10.677 17.7374 10.9699 18.0303L12.0305 16.9697ZM10.9699 19.9697C10.677 20.2626 10.677 20.7374 10.9699 21.0303C11.2628 21.3232 11.7377 21.3232 12.0305 21.0303L10.9699 19.9697ZM16.1321 4.25H11.0002V5.75H16.1321V4.25ZM13.0002 18.25H7.86833V19.75H13.0002V18.25ZM16.8032 8.05458L6.39193 14.6799L7.19725 15.9454L17.6085 9.32007L16.8032 8.05458ZM13.5305 18.4697L12.0305 16.9697L10.9699 18.0303L12.4699 19.5303L13.5305 18.4697ZM12.4699 18.4697L10.9699 19.9697L12.0305 21.0303L13.5305 19.5303L12.4699 18.4697ZM7.86833 18.25C6.61778 18.25 6.14219 16.6168 7.19725 15.9454L6.39193 14.6799C4.07083 16.157 5.11709 19.75 7.86833 19.75V18.25ZM16.1321 5.75C17.3827 5.75 17.8582 7.38318 16.8032 8.05458L17.6085 9.32007C19.9296 7.843 18.8833 4.25 16.1321 4.25V5.75Z",
    fill: "#ffffff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathways);
export default __webpack_public_path__ + "static/media/pathways.a801459999bd47a1f3b872fae8185e8d.svg";
export { ForwardRef as ReactComponent };